import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import flayer from "../assets/flayerNew.png"

const Convocatoria = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      
      <div className='bg-white min-h-screen pt-28 pb-12'>
        
        {/* Sección Hero / Título */}
        <div className='max-w-[1200px] mx-auto px-4 text-center mb-16'>
          <div className='inline-block bg-red-100 text-red-600 px-4 py-1 rounded-full text-sm font-bold mb-4 animate-pulse'>
            ¡INSCRIPCIONES ABIERTAS!
          </div>
          <h1 className='text-5xl md:text-7xl font-black text-slate-900 mb-6 tracking-tighter'>
            CONVOCATORIA <span className='text-red-600'>2026</span>
          </h1>
          <p className='text-slate-500 text-lg md:text-xl max-w-2xl mx-auto font-light'>
            Participa en el Premio a la Vida y Obra del Pedagogo. Descarga los documentos necesarios a continuación.
          </p>
        </div>

        {/* Botones de Documentos */}
        <div className='max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 px-6 mb-24'>
          <a 
            target='_blank' 
            rel="noreferrer"
            href='https://docs.google.com/document/d/1BaRhOcA0SILrtwqTuHEQ-xfOtK9ExTyg/edit?usp=sharing&ouid=112803265565005618269&rtpof=true&sd=true'
            className='group bg-blue-600 hover:bg-blue-700 p-8 rounded-[2rem] text-center transition-all duration-300 transform hover:-translate-y-2 shadow-xl shadow-blue-100'
          >
            <div className='text-5xl mb-4'>📋</div>
            <h3 className='text-white text-xl font-bold mb-2'>Requisitos / Criterios</h3>
            <p className='text-blue-100 text-sm'>Consulta las bases legales y condiciones</p>
          </a>

          <a 
            target='_blank' 
            rel="noreferrer"
            href='https://docs.google.com/document/d/1_-c9mtfsXWGuzMCK-GPVFr5g-YJqgIhx/edit?usp=sharing&ouid=112803265565005618269&rtpof=true&sd=true'
            className='group bg-slate-900 hover:bg-black p-8 rounded-[2rem] text-center transition-all duration-300 transform hover:-translate-y-2 shadow-xl shadow-slate-200'
          >
            <div className='text-5xl mb-4'>✍️</div>
            <h3 className='text-white text-xl font-bold mb-2'>Formato de Inscripción</h3>
            <p className='text-slate-400 text-sm'>Descarga y diligencia el formulario</p>
          </a>
        </div>

        {/* Sección Cronograma de Eventos */}
        <div className='bg-slate-50 py-20 px-4'>
          <div className='max-w-[1200px] mx-auto'>
            <h2 className='text-4xl font-black text-center text-slate-900 mb-16 tracking-tight uppercase italic'>
              Cronograma de <span className='text-red-600 font-light'>Eventos</span>
            </h2>

            <div className='grid md:grid-cols-2 gap-12'>
              {/* Evento 1 */}
              <div className='bg-white p-10 rounded-[2.5rem] border border-slate-200 shadow-sm relative overflow-hidden group'>
                <div className='absolute top-0 right-0 bg-red-600 text-white px-6 py-2 rounded-bl-3xl font-bold'>
                  ABR 22
                </div>
                <h3 className='text-xl font-bold text-slate-900 mb-4 pr-16'>
                  Lanzamiento de la convocatoria
                </h3>
                <p className='text-slate-600 leading-relaxed'>
                  En reunión con profesores y directivos se dará lanzamiento oficial a la convocatoria del Premio a la Vida y Obra del Pedagogo.
                </p>
                <div className='mt-6 w-12 h-1 bg-red-600 transition-all group-hover:w-24'></div>
              </div>

              {/* Evento 2 */}
              <div className='bg-white p-10 rounded-[2.5rem] border border-slate-200 shadow-sm relative overflow-hidden group'>
                <div className='absolute top-0 right-0 bg-red-600 text-white px-6 py-2 rounded-bl-3xl font-bold'>
                  AGO 27
                </div>
                <h3 className='text-xl font-bold text-slate-900 mb-4 pr-16'>
                  Fecha límite de inscripción
                </h3>
                <p className='text-slate-600 leading-relaxed'>
                  Cierre de inscripciones para nominados y entrega de ensayos motivados a través del diligenciamiento del formato oficial.
                </p>
                <div className='mt-6 w-12 h-1 bg-red-600 transition-all group-hover:w-24'></div>
              </div>
            </div>
          </div>
        </div>

        {/* Imagen / Flayer Final */}
        <div className='max-w-[1100px] mx-auto px-4 mt-20 mb-12'>
          <div className='relative group'>
            <div className='absolute -inset-1 bg-gradient-to-r from-red-600 to-blue-600 rounded-[2rem] blur opacity-25 group-hover:opacity-50 transition duration-1000'></div>
            <img 
              className='relative w-full rounded-[2rem] shadow-2xl transition-transform duration-500 hover:scale-[1.01]' 
              src={flayer} 
              alt='Flayer de la convocatoria' 
            />
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default Convocatoria;